import { render, staticRenderFns } from "./AddSeguroicancelarPage.vue?vue&type=template&id=2e6827e1"
import script from "./AddSeguroicancelarPage.vue?vue&type=script&lang=js"
export * from "./AddSeguroicancelarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports